import { useState } from 'react';
import { formatWhatsAppMessage } from '../utils/orderUtils';
import { useCatalog } from '../context/CatalogContext.jsx';
import { DEFAULT_CATALOG, DEFAULT_WHATSAPP_CONFIG } from '../config/catalog';

/**
 * Custom hook for managing WhatsApp checkout process
 * @returns {Object} Checkout state and actions
 */
export const useWhatsAppCheckout = () => {
  const { catalog } = useCatalog();
  const data = catalog ?? DEFAULT_CATALOG;
  const whatsappConfig = data.whatsapp ?? DEFAULT_WHATSAPP_CONFIG;
  const [openCheckout, setOpenCheckout] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const processCheckout = async (cartItems, onSuccess) => {
    if (cartItems.length === 0) return;
    
    setSubmitting(true);
    
    try {
      // Generate WhatsApp message
      if (!whatsappConfig?.phoneNumber) {
        throw new Error('Configuración de WhatsApp no disponible');
      }

      const message = formatWhatsAppMessage(cartItems, data, whatsappConfig);

      // Create WhatsApp URL
      const encodedMessage = encodeURIComponent(message);
      const whatsappUrl = `https://wa.me/${whatsappConfig.phoneNumber}?text=${encodedMessage}`;
      
      // Open WhatsApp in a new tab/window
      window.open(whatsappUrl, '_blank');
      
      // Execute success callback after a short delay
      setTimeout(() => {
        if (onSuccess) onSuccess();
        setOpenCheckout(false);
        setSubmitting(false);
      }, 1000);
      
    } catch (error) {
      console.error('Error generating WhatsApp message:', error);
      alert('Error al generar el mensaje de WhatsApp. Por favor, intenta nuevamente.');
      setSubmitting(false);
    }
  };

  return {
    openCheckout,
    submitting,
    setOpenCheckout,
    processCheckout,
  };
};
